var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 473 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.293 231.384C447.866 190.89 414.18 156.926 373.876 133.167C332.347 108.686 284.777 95.7461 236.309 95.7461C187.841 95.7461 140.27 108.686 98.741 133.167C58.437 156.927 24.751 190.89 1.32495 231.384C-0.439047 234.435 -0.439047 238.195 1.32495 241.246C24.751 281.741 58.437 315.705 98.741 339.463C140.271 363.945 187.841 376.885 236.309 376.885C284.777 376.885 332.347 363.945 373.876 339.463C414.18 315.704 447.866 281.741 471.293 241.246C473.057 238.194 473.057 234.435 471.293 231.384ZM363.875 322.499C325.373 345.195 281.262 357.192 236.308 357.192C191.354 357.192 147.242 345.195 108.741 322.499C72.9989 301.429 42.867 271.709 21.298 236.314C42.867 200.92 72.9989 171.2 108.741 150.13C147.242 127.434 191.354 115.437 236.308 115.437C281.262 115.437 325.373 127.434 363.875 150.13C399.616 171.2 429.748 200.919 451.318 236.314C429.748 271.709 399.617 301.429 363.875 322.499Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.307 147.84C187.521 147.84 147.832 187.529 147.832 236.315C147.832 285.101 187.521 324.791 236.307 324.791C285.093 324.791 324.783 285.101 324.783 236.315C324.783 187.53 285.092 147.84 236.307 147.84ZM236.307 305.099C198.38 305.099 167.524 274.243 167.524 236.315C167.524 198.388 198.38 167.532 236.307 167.532C274.235 167.532 305.091 198.388 305.091 236.315C305.091 274.243 274.235 305.099 236.307 305.099Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472.616,
    height: 472.616,
    fill: "white",
    transform: "translate(0 0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.912406f52f8e7b3898237128de42f620.svg";
export { ForwardRef as ReactComponent };